declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, UpdateIvfCycleByActivityRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, SaveSingleWellFollicleRequest, SaveOocyteMaturityInfoRequest, SaveOocyteMorphologyInfoRequest, SaveIvfOocyteEmbryoStorageRequest, SaveCycleStatusRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, OqaDetails, OocyteAbnormalitiesDetails, SpermSourceDetailsController, SpermSourceDetailsRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest, SaveSpermDetailsRequest, SaveSemenDataRequest, SaveIvfSpermStoreRequest, SaveSingleWellInseminationInfoRequest, SaveIvfCycleInseminationLogRequest, SaveIvfCycleInseminationInfoRequest, CompleteIvfCycleInseminationRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe, OocyteAbPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';
import { NgbSearchProviderModal } from '../ivfworkbench/searchprovider.modal';
import { NgbAddOqaModal } from '../ivfworkbench/addoqa.modal';
import { NgbEditOqaModal } from '../ivfworkbench/editoqa.modal';
import { NgbAddAbnormalOqaModal } from '../ivfworkbench/addabnormaloqa.modal';
import { NgbEditAbnormalOqaModal } from '../ivfworkbench/editabnormaloqa.modal';
import { NgbSearchDonarModal } from './searchdonar.modal';
import { NgbAddInseminationLogModal } from '../ivfworkbench/addinseminationlog.modal';
import { NgbEditInsemiModal } from '../ivfworkbench/editinsemi.modal';
import { NgbEditInseminationLogModal } from '../ivfworkbench/editinseminationlog.modal';

@Component({
  selector: 'inseminationedit',
  templateUrl: './inseminationedit.modal.html',
  styleUrls: ['./inseminationedit.modal.scss']
})

export class NgbInseminationEditModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() ActorCode: number;
  @Input() TemplateName: string;
  @Input() CycleCode: number;
  @Input() FollicularGrowthCode: number;
  @Input() ActivityCode: number;
  @Input() PatientCode: number;
  @Input() FormattedCode: string;
  @Input() IsShowDetail: boolean = false;
  @Input() SectionSequenceNO: number;
  @Input() SectionTypeCode: number;
  @Input() Date: Date;
  @Input() Sign1: string;
  @Input() Sign2: string;
  @Input() TitleName: string;
  @Input() DOC: number;
  @Input() GradingModel: string;
  @Input() sectionData: SectionData;
  @Input() PatientReportCode: any;
  OvulationTriggerDate: NgbDateStruct;
  public ActivityDate: NgbDateStruct;
  public displayPatientdata: boolean = true;
  public displayscansdata: boolean = false;
  @Input() Eggsourcetype: string;
  public EggSourceType: string;
  ExpiryDate: NgbDateStruct;
  ExpiryDate2: NgbDateStruct;
  OvumPickupdate: NgbDateStruct;
  OvumPlannedPickupDate: NgbDateStruct;
  DateofSampleCollection: NgbDateStruct;
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  ScanDate: NgbDateStruct;
  NextScanDate: NgbDateStruct;
  public EggSourceActorCode: number;
  public OvulationtriggerDate: Date;
  //private isvisibleendo: boolean = true;
  public ApiResData: ApiResponseModel;
  // public data: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  private isvisible: boolean = true;
  public ActivityCodeNew: number;
  private isvisibleendo: boolean = true;
  public ProvidedName: string;

  public ProvidedCode: number;
  public ProvidedNumber: number;
  public ProvidedName2: string;
  public ProvidedCode2: number;
  public ProvidedNumber2: number;
  public length: number;
  public Displaynew: boolean = false;
  public Displayold: boolean = true;
  //public IsSelected: boolean;
  ExtractionDate: NgbDateStruct;
  CurrentSaveSingleWellInseminationInfoRequest: SaveSingleWellInseminationInfoRequest;
  CurrentSaveIvfCycleInseminationLogRequest: SaveIvfCycleInseminationLogRequest;
  CurrentEditIvfCycleInseminationInfoRequest: SaveIvfCycleInseminationInfoRequest;
  CurrentCompleteIvfCycleInseminationRequest: CompleteIvfCycleInseminationRequest;
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedpatientDetails: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    // alert("patientsdetails");
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          /// this.LoadDSAData();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter, private filter2: OocyteAbPipe, ) { }
  ngOnInit() {

    this.ShowService = false;
    this.CurrentSaveSingleWellInseminationInfoRequest = new SaveSingleWellInseminationInfoRequest();
    this.CurrentSaveSingleWellInseminationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfCycleInseminationLogRequest = new SaveIvfCycleInseminationLogRequest();

    this.CurrentSaveIvfCycleInseminationLogRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditIvfCycleInseminationInfoRequest = new SaveIvfCycleInseminationInfoRequest();
    this.CurrentEditIvfCycleInseminationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentCompleteIvfCycleInseminationRequest = new CompleteIvfCycleInseminationRequest();
    this.CurrentCompleteIvfCycleInseminationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadPatients();
    this.LoadInsemination();
    this.LoadInsemination2();
    this.LoadOqaData();
    this.LoadCycles();
    this.LoadInseminationDatacycle();

    //this.LoadScansData();
    //this.LoadOvaryData();

    //this.LoadTestData();
    //this.LoadMedicineData();

  }



  CurrentSingleWellInseminationByCycleController: SingleWellInseminationByCycleController[];
  CurrentSingleWellInseminationByCycleRequest: SingleWellInseminationByCycleRequest;
  LoadInsemination() {
    this.CurrentSingleWellInseminationByCycleRequest = new SingleWellInseminationByCycleRequest();
    this.CurrentSingleWellInseminationByCycleRequest.TreatmentCycle = this.CycleCode;
    this.CurrentSingleWellInseminationByCycleRequest.ConditionalOperator = 10;
    this.CurrentSingleWellInseminationByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetSingleWellInseminationByCycleController();
  }
  GetSingleWellInseminationByCycleController() {
    //this.StartRefreshing();


    this.actorservice.GetSingleWellInseminationByCycleController(this.CurrentSingleWellInseminationByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSingleWellInseminationByCycleController = this.ApiResData.Result;
          this.length = this.CurrentSingleWellInseminationByCycleController.length;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //  this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  onSubmit(data: SingleWellInseminationByCycleController) {


    this.CurrentSaveSingleWellInseminationInfoRequest.ConditionalOperator = 1;
    this.CurrentSaveSingleWellInseminationInfoRequest.InseminationDate = new Date();
    this.CurrentSaveSingleWellInseminationInfoRequest.WellFollicle = data.WellFollicle;
    this.CurrentSaveSingleWellInseminationInfoRequest.technique = data.technique;



    this.actorservice.SaveSingleWellInseminationInfo(this.CurrentSaveSingleWellInseminationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.LoadInsemination();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  CurrentIvfCycleInseminationLogByCycleWithDOCController: IvfCycleInseminationLogByCycleWithDOCController[];
  InseminationEndInfo: IvfCycleInseminationLogByCycleWithDOCController;
  CurrentIvfCycleInseminationLogByCycleWithDOCRequest: IvfCycleInseminationLogByCycleWithDOCRequest;
  LoadInsemination2() {
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest = new IvfCycleInseminationLogByCycleWithDOCRequest();
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.TreatmentCycle = this.CycleCode;
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.DOC = 1;
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.ConditionalOperator = 10;
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleInseminationLogByCycleWithDOCController();
  }
  GetIvfCycleInseminationLogByCycleWithDOCController() {
    // this.StartRefreshing();


    this.actorservice.GetIvfCycleInseminationLogByCycleWithDOCController(this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfCycleInseminationLogByCycleWithDOCController = this.ApiResData.Result;
          this.InseminationEndInfo = this.CurrentIvfCycleInseminationLogByCycleWithDOCController[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          // this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //Selectedpatient() {
  //  this.ScanDetails = true;
  //}
  CurrentIvfOocyteEmbryoStorageByCodeController: IvfOocyteEmbryoStorageByCodeController[];
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    //this.StartRefreshing();

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.CycleCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;
          // this.length = this.CurrentIvfOocyteEmbryoStorageByCodeController.length;

          //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          // this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadPatients();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  InseminationData: TreatmentCycleStatusController[];
  InseminationData2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    // this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
    //this.spinner.show();
    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.InseminationData = this.ApiResData.Result;
          var Inseminationlist = this.InseminationData.filter(
            function (g) {
              return g.PhaseActivity == "Insemination";
            });
          this.InseminationData = Inseminationlist;
          this.InseminationData2 = this.InseminationData[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //    GetDsADetails(ActorCode: number, Date: Date) {


  //}
  GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
      return OwnerActorCode;
    }
  }
  CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
  ActivityCodeInfo: TreatmentCycleActiityMasterController;
  CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

  LoadMasterReq() {
    //alert("ScansData")
    this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCycleActiityMasterController();
  }

  GetTreatmentCycleActiityMasterController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
    this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;

          //this.LoadTestData();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.GetCycleActivity(this.ActorCode, this.ScanDate);

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentTreatmentCycleActiityMasterController.filter(
      function (v, i, d) {

        return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
      }
    )

  }

  Addactivity() {
    const modalRef = this.modalService.open(NgbAddInseminationLogModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.TreatmentCycleCode = this.CycleCode;
    modalRef.componentInstance.Gradingmodel = this.GradingModel;
    modalRef.componentInstance.Doctor = this.InseminationEndInfo.Doctor;
    modalRef.componentInstance.ProcessedBy = this.InseminationEndInfo.ProcessedBy;
    modalRef.componentInstance.Nurse = this.InseminationEndInfo.Nurse;
    modalRef.result.then(x => { this.GetIvfCycleInseminationLogByCycleWithDOCController() })
    //modalRef.componentInstance.InseminationTime = this.InseminationEndInfo.InseminationTime;

  }
  AddInsemination() {
    const modalRef = this.modalService.open(NgbEditInsemiModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.Mode = "New";
    modalRef.componentInstance.CycleCode = this.CycleCode;
    modalRef.result.then(x => { this.GetIvfCycleInseminationByCycleController() })
  }
  Editinsemi(datanew: IvfCycleInseminationByCycleController) {
    this.CurrentEditIvfCycleInseminationInfoRequest.ConditionalOperator = 20;
    this.CurrentEditIvfCycleInseminationInfoRequest.CycleCode = this.CycleCode;
    this.CurrentEditIvfCycleInseminationInfoRequest.OocyteCount = datanew.OocyteCount;
    this.CurrentEditIvfCycleInseminationInfoRequest.InseminationCode = datanew.InseminationCode;
    this.CurrentEditIvfCycleInseminationInfoRequest.Technique = datanew.Technique;
    this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy = datanew.PrescribedBy;
    this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName = datanew.PrescribedByName;
    this.CurrentEditIvfCycleInseminationInfoRequest.Remarks = datanew.Remarks;


    const modalRef = this.modalService.open(NgbEditInsemiModal,
      {
        centered: true

      })
    modalRef.componentInstance.Mode = "Edit";
    modalRef.componentInstance.CurrentEditIvfCycleInseminationInfoRequest = this.CurrentEditIvfCycleInseminationInfoRequest;
    modalRef.result.then(x => { this.GetIvfCycleInseminationByCycleController() })
  }

  Editactivity(l: IvfCycleInseminationLogByCycleWithDOCController) {
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate = l.InseminationDate;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTime = l.InseminationTime;
    this.CurrentSaveIvfCycleInseminationLogRequest.DateofCollection = l.DateofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TimeofCollection = l.TimeofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TreatmentCycleCode = l.TreatmentCycle;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doc = l.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = l.DoctorName;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = l.Doctor;
    this.CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed = l.NtimesInformed;
    this.CurrentSaveIvfCycleInseminationLogRequest.IterationType = l.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = l.Nurse;
    this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = l.NurseName;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = l.ProcessedBy;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = l.ProcessedByName;
    this.CurrentSaveIvfCycleInseminationLogRequest.SlideObserved = l.SlideObserved;
    this.CurrentSaveIvfCycleInseminationLogRequest.Patient = l.Patient;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationLogCode = l.InseminationLogCode;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTimeText = l.InseminationTimeText;
    this.CurrentSaveIvfCycleInseminationLogRequest.RecordStatus = l.RecordStatus;
    const modalRef = this.modalService.open(NgbEditInseminationLogModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.Gradingmodel = this.GradingModel;
    modalRef.componentInstance.CurrentSaveIvfCycleInseminationLogRequest = this.CurrentSaveIvfCycleInseminationLogRequest;
    modalRef.result.then(x => { this.GetIvfCycleInseminationLogByCycleWithDOCController() })
  }
  Insemination() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.IsinseminationCompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  IsinseminationCompleted() {


    console.log('..................');
    // this.StartRefreshing();
    //this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 3;
    this.CurrentCompleteIvfCycleInseminationRequest.CycleCode = this.CycleCode;
    this.CurrentCompleteIvfCycleInseminationRequest.DateOfInsemination = this.InseminationEndInfo.InseminationDate;
    this.CurrentCompleteIvfCycleInseminationRequest.TimeOfInsemination = this.InseminationEndInfo.InseminationTime;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.CompleteIvfCycleInsemination(this.CurrentCompleteIvfCycleInseminationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();
            this.LoadCycles();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  InseminationIUI() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.IsInseminationIUICompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  IsInseminationIUICompleted() {


    console.log('..................');
    // this.StartRefreshing();
    this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 1;
    this.CurrentCompleteIvfCycleInseminationRequest.CycleCode = this.CycleCode;
    this.CurrentCompleteIvfCycleInseminationRequest.DateOfInsemination = this.InseminationEndInfo.InseminationDate;
    this.CurrentCompleteIvfCycleInseminationRequest.TimeOfInsemination = this.InseminationEndInfo.InseminationTime;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.CompleteIvfCycleInsemination(this.CurrentCompleteIvfCycleInseminationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();
            this.LoadCycles();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  CurrentIvfCycleInseminationByCycleController: IvfCycleInseminationByCycleController[];
  CurrentIvfCycleInseminationByCycleRequest: IvfCycleInseminationByCycleRequest;

  LoadInseminationDatacycle() {
    //alert("ScansData")
    this.CurrentIvfCycleInseminationByCycleRequest = new IvfCycleInseminationByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleInseminationByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleInseminationByCycleController();
  }

  GetIvfCycleInseminationByCycleController() {
    // this.StartRefreshing();

    this.CurrentIvfCycleInseminationByCycleRequest.CycleCode = this.CycleCode;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleInseminationByCycleController(this.CurrentIvfCycleInseminationByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleInseminationByCycleController = this.ApiResData.Result;


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  delLog(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteLog(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteLog(l: any) {
    var item = l as IvfCycleInseminationLogByCycleWithDOCController;



    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveIvfCycleInseminationLogRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate = item.InseminationDate;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTime = item.InseminationTime;
    this.CurrentSaveIvfCycleInseminationLogRequest.DateofCollection = item.DateofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TimeofCollection = item.TimeofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TreatmentCycleCode = item.TreatmentCycle;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doc = item.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = item.DoctorName;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = item.Doctor;
    this.CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed = item.NtimesInformed;
    this.CurrentSaveIvfCycleInseminationLogRequest.IterationType = item.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = item.Nurse;
    this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = item.NurseName;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = item.ProcessedBy;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = item.ProcessedByName;
    this.CurrentSaveIvfCycleInseminationLogRequest.SlideObserved = item.SlideObserved;
    this.CurrentSaveIvfCycleInseminationLogRequest.Patient = item.Patient;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationLogCode = item.InseminationLogCode;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTimeText = item.InseminationTimeText;
    this.CurrentSaveIvfCycleInseminationLogRequest.RecordStatus = item.RecordStatus;


    //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentSaveIvfCycleInseminationLogRequest.ActorCode = this.SelectedpatientDetails.ActorID;

    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveIvfCycleInseminationLog(this.CurrentSaveIvfCycleInseminationLogRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            //this.LoadOvaryData();
            this.LoadInsemination2();
            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }


  BackToPatientdata() {
    this.displayPatientdata = true;
    this.displayscansdata = false;
  }
  BackTodashboard2() {
    //this.Showivf = true;
    //this.Showscan = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  printinsemi() {
    this.printService.printDocument("inseminationlog",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.Code, ActorCodedata: this.SelectedpatientDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        InsemDate: this.InseminationEndInfo.InseminationDate, InsemTime: this.InseminationEndInfo.InseminationTime, NtimesInf: this.InseminationEndInfo.NtimesInformed, ProcessedBy: this.InseminationEndInfo.ProcessedByName, Doctor: this.InseminationEndInfo.DoctorName, Details: this.InseminationEndInfo.IterationType, Nurse: this.InseminationEndInfo.NurseName,

      }
    );
  }

  printinsemidroplet() {
    this.printService.printDocument("inseminationlogdroplet",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.Code, ActorCodedata: this.SelectedpatientDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        InsemDate: this.InseminationEndInfo.InseminationDate, InsemTime: this.InseminationEndInfo.InseminationTime, NtimesInf: this.InseminationEndInfo.NtimesInformed, ProcessedBy: this.InseminationEndInfo.ProcessedByName, Doctor: this.InseminationEndInfo.DoctorName, Details: this.InseminationEndInfo.IterationType, Nurse: this.InseminationEndInfo.NurseName,

      }
    );
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}

